import TreeBuilder from './builder';
import * as d3 from 'd3';
import _ from 'lodash';
import {birthToDate, formatDeadKey} from './feed';

const dTree = {

    VERSION: '/* @echo DTREE_VERSION */',
  
    init: function(data, options = {}) {
  
      var opts = _.defaultsDeep(options || {}, {
        target: options.target,
        debug: false,
        width: 600,
        height: 600,
        hideMarriageNodes: true,
        callbacks: {
          nodeClick: function(name, extra, id) {},
          nodeRightClick: function(name, extra, id) {},
          marriageClick: function(extra, id) {},
          marriageRightClick: function(extra, id) {},
          nodeHeightSeperation: function(nodeWidth, nodeMaxHeight) {
            return TreeBuilder._nodeHeightSeperation(nodeWidth, nodeMaxHeight);
          },
          nodeRenderer: function(name, userId, x, y, height, width, extra, id, nodeClass, textClass, textRenderer) {
            return TreeBuilder._nodeRenderer(name, userId, x, y, height, width, extra,
              id,nodeClass, textClass, textRenderer);
          },
          nodeSize: function(nodes, width, textRenderer) {
            return TreeBuilder._nodeSize(nodes, width, textRenderer);
          },
          nodeSorter: function(aName, aExtra, bName, bExtra) {return 0;},
          textRenderer: function(name, userId, extra, textClass) {
            return TreeBuilder._textRenderer(name, userId, extra, textClass);
          },
          marriageRenderer: function (x, y, height, width, extra, id, nodeClass) {
            return TreeBuilder._marriageRenderer(x, y, height, width, extra, id, nodeClass)
          },
          marriageSize: function (nodes, size) {
            return TreeBuilder._marriageSize(nodes, size)
          },
        },
        margin: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
        nodeWidth: 80,
        marriageNodeSize: 10,
        styles: {
          node: 'node',
          marriageNode: 'marriageNode',
          linage: 'linage',
          marriage: 'marriage',
          text: 'nodeText'
        }
      });

      var data = this._preprocess(data, opts);
      var treeBuilder = new TreeBuilder(data.root, data.siblings, opts);
      treeBuilder.create();
  
      function _zoomTo (x, y, zoom = 1, duration = 500) {
        treeBuilder.svg
          .transition()
          .duration(duration)
          .call(
            treeBuilder.zoom.transform,
            d3.zoomIdentity
              .translate(opts.width / 2, opts.height / 2)
              .scale(zoom)
              .translate(-x, -y)
          )
      }
  
      return {
        resetZoom: function (duration = 500) {
          treeBuilder.svg
            .transition()
            .duration(duration)
            .call(
              treeBuilder.zoom.transform,
              d3.zoomIdentity.translate(opts.width / 2, opts.margin.top).scale(1)
            )
        },
        zoomTo: _zoomTo,
        zoomToNode: function (nodeId, zoom = 2, duration = 500) {
          const node = _.find(treeBuilder.allNodes, {data: {id: nodeId}})
          if (node) {
            _zoomTo(node.x, node.y, zoom, duration)
          }
        },
        zoomToFit: function (duration = 500) {
          const groupBounds = treeBuilder.g.node().getBBox()
          const width = groupBounds.width
          const height = groupBounds.height
          const fullWidth = treeBuilder.svg.node().clientWidth
          const fullHeight = treeBuilder.svg.node().clientHeight
          const scale = 0.95 / Math.max(width / fullWidth, height / fullHeight)
  
          treeBuilder.svg
            .transition()
            .duration(duration)
            .call(
              treeBuilder.zoom.transform,
              d3.zoomIdentity
                .translate(
                  fullWidth / 2 - scale * (groupBounds.x + width / 2),
                  fullHeight / 2 - scale * (groupBounds.y + height / 2)
                )
                .scale(scale)
            )
        }
      }
    },
  
    _preprocess: function(data, opts) {
  
      var siblings = [];
      var id = 0;
      
      var root = {
        name: '',
        id: id++,
        hidden: true,
        children: []
      };
      var reconstructTree = function(person, parent) {
        // console.log(person)
        // console.log(parent)
        // convert to person to d3 node
        if (opts.hasOwnProperty("stopNode") && opts.stopNode!="") {
          if (person.userId==opts.stopNode) {
            return false
          }
        }

        var node = {
          name: person.userName == "null" ? "?" : person.userName,
          id: id++,
          userId: person.userId,     
          hidden: false,
          children: [],
          extra: person.extra,
          textClass: person.textClass ? person.textClass : opts.styles.text,
          class: person.sex==1 ? "man" : "woman"
        };

        let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
        if (loginUser.userId==person.userId) {
          node.class+= ' is-me'
        }

        // hide linages to the hidden root node
        if (parent == root) {
          node.noParent = true;
        }
        
        // apply depth offset
        for (var i = 0; i < person.depthOffset; i++) {
          var pushNode = {
            name: '',
            id: id++,
            hidden: true,
            children: [],
            noParent: node.noParent
          };
          parent.children.push(pushNode);
          parent = pushNode;
        }
  
        // sort children
        dTree._sortPersons(person.partnerPublicChildren, opts);
  
        // add "direct" children
        // _.forEach(person.partnerPublicChildren, function(children) {
        //     _.forEach(children,function(child){
        //         reconstructTree(child, node);
        //     });
        // });
  
        parent.children.push(node);
  
        //sort marriages
        dTree._sortMarriages(person.partners, opts);
  
        // go through marriage
        _.forEach(person.partners, function(marriage, index) {
          var m = {
            name: '',
            id: id++,
            hidden: opts.hideMarriageNodes,
            noParent: true,
            children: [],
            isMarriage: true,
            extra: marriage.extra,
            class: marriage.class ? marriage.class : opts.styles.marriageNode
          }
  
          var sp = marriage;
  
          var spouse = {
            name: sp.userName=="null" ? "?" : sp.userName,
            id: id++,
            userId: sp.userId,
            hidden: false,
            noParent: true,
            children: [],
            textClass: sp.textClass ? sp.textClass : opts.styles.text,
            class: sp.sex==1 ? "man" : "woman",
            extra: sp.extra,
            marriageNode: m
          };
  
          parent.children.push(m, spouse);
  
          // dTree._sortPersons(marriage.children, opts);
          
  
          // _.forEach(marriage.children, function(child) {
          //   reconstructTree(child, m);
          // });

          var sortedSiblings = dTree._sortSiblings(person.partnerPublicChildren[index]);

          _.forEach(sortedSiblings, function(child) {
            reconstructTree(child, m);
          });
  
          siblings.push({
            source: {
              id: node.id
            },
            target: {
              id: spouse.id
            },
            number: index
          });
        });
  
      };
  
      reconstructTree(data, root);
      return {
        root: d3.hierarchy(root),
        siblings: siblings
      };
  
    },
  
    _sortPersons: function(persons, opts) {
      if (persons != undefined) {
        persons.sort(function(a, b) {
          return opts.callbacks.nodeSorter.call(this, a.userName, a.extra, b.userName, b.extra);
        });
      }
      return persons;
    },
  
    _sortMarriages: function(marriages, opts) {
      if (marriages != undefined && Array.isArray(marriages)) {
        marriages.sort(function(marriageA, marriageB) {
          var a = marriageA;
          var b = marriageB;
          return opts.callbacks.nodeSorter.call(this, a.userName, a.extra, b.userName, b.extra);
        });
      }
      return marriages;
    },

    _sortSiblings: function(jsonObj) {
      var newArray = new Array();
            var tempJson = {};
            if (Array.isArray(jsonObj) && jsonObj.length>1) {
                var birthArr = new Array();
                var birthIdArr = [];
                var nonBirthPerson = [];
                // var regExp = /^[0-9.-]+$/;
                var regExp = /^[\-|0-9][0-9]*/;
                for(let i =0;i<jsonObj.length;i++){

                    //将有生日的节点的生日和ID保存在生日数组中
                    if (regExp.test(jsonObj[i].birthday) && jsonObj[i].birthday != "0") {
                        var birthKey = '';
                        if (jsonObj[i].status==0) {
                            birthKey = birthToDate(jsonObj[i].birthday);
                        }else if (jsonObj[i].status==2) {
                            birthKey = formatDeadKey(jsonObj[i].birthday);
                        }
                        birthArr.push(
                            {
                                'birthday': birthKey,
                                'userId': jsonObj[i].userId
                            }
                        )
                    }else {
                        nonBirthPerson.push(jsonObj[i]);
                    }
                    var userId = jsonObj[i].userId;

                    //将所有节点放在临时对象中
                    tempJson[userId] = {
                        'userId':jsonObj[i].userId,
                        'sex':jsonObj[i].sex,
                        'addTime':jsonObj[i].addTime,
                        'userName':jsonObj[i].userName,
                        'birthday':jsonObj[i].birthday,
                        'partnerPublicChildren':jsonObj[i].partnerPublicChildren,
                        'partners':jsonObj[i].partners,
                        'status':jsonObj[i].status
                    };
                }

                //对有生日的节点排序，取得对应的ID
                if (birthArr.length>0) {
                    var sortBirth = _.sortBy(birthArr, ['birthday']);
                    birthIdArr = Array.from(sortBirth.map(d=>(d['userId'])));
                }


                if (birthIdArr.length>0) {
                    for (let x=0; x < birthIdArr.length;x++) {
                        var mixtureKey = birthIdArr[x];
                        if (tempJson[mixtureKey]) {
                            newArray[x] = tempJson[mixtureKey];
                        }
                    }
                }

                if (nonBirthPerson.length!=0) {
                    for (let m=0; m < nonBirthPerson.length;m++) {
                        var findArr = newArray.filter(item=>item.userId===nonBirthPerson[m].userId);
                        if (findArr.length==0) {
                            newArray.push(nonBirthPerson[m])
                        }
                    }
                }
            }else {
                newArray = jsonObj;
            }
            return newArray;
    }
  
  };
  
export default dTree;
  